import axios from 'axios';

import {PDF_MIME_TYPE} from 'shared/web';

import {ServiceCaseInvoiceType} from '../types/ServiceCaseInvoiceType';

export const exportServiceCaseInvoicePdf = (invoiceId: string, type: ServiceCaseInvoiceType) =>
  axios
    .post<ArrayBuffer>(
      `/v1/workshop/${type}/${encodeURIComponent(invoiceId)}/export`,
      {},
      {responseType: 'arraybuffer', headers: {Accept: PDF_MIME_TYPE}}
    )
    .then((response) => {
      // The 401 interceptor resolves with the error instead of rejecting.
      if (!(response.data instanceof ArrayBuffer) || response.data.byteLength === 0) {
        throw new Error(`The ${type} export endpoint returned no document`);
      }

      return new Blob([response.data], {type: PDF_MIME_TYPE});
    });
